import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiConfig, getApiUrl } from 'src/config/apiConfig';
import axiosIn from 'src/middlewares/axiosInterceptor';
import { dispatch } from '../Store';
import { setIsLoadings, setPersist } from './app';

const initialState: any = {
  fetchedData: {
    tabId_main: [],
  },
  currentPaginationOfTabs: {
    tabId_main: 0,
  },
  currentPageSizeOfTabs: {
    tabId_main: 25,
  },
  currentTab: 'tabId_main',

  searchForm: {},

  actionButtonStates: { filter: { show: false, data: {} }, order: { show: false, data: {} }, plus: { show: false, data: {} } },
};

export const fetchSummary: any = createAsyncThunk<any, any>('SummaryPageSlice/fetchedData_main', async ({ csrftoken, page, pageSize, shouldUpdateState = true }: any, { getState }) => {
  // NOT IN USE since no table in overview page
  let state = getState() as any;
  state = state.summaryReducer;

  const createQueryUrl = () => {
    try {
      const queryParams: any = {
        page: page ? page : state.currentPaginationOfTabs?.[state.currentTab] + 1, // Gives the error here
        page_size: pageSize ? pageSize : state.currentPageSizeOfTabs[state.currentTab],
      };

      // Remove empty or null fields from the query params
      const filteredQueryParams = Object.entries(queryParams)
        .filter(([_, value]) => value !== null && value !== '' && value !== undefined)
        .map(([key, value]: any) => `${key}=${encodeURIComponent(value)}`)
        .join('&');

      // Construct the final URL
      return apiConfig.API_URL + apiConfig.example_slug + '?' + filteredQueryParams;
    } catch (error) {
      console.error('error: ', error);
    }
  };

  const curl = createQueryUrl() || '';

  return { res: { data: mockdata, total: 100 }, shouldUpdateState: shouldUpdateState }; // TODO TEST

  if (state.currentTab) {
    try {
      const response = await axios.get(curl, {
        headers: {
          'X-CSRFToken': csrftoken,
        },
        withCredentials: true,
      });
      return { res: response.data, shouldUpdateState: shouldUpdateState };
    } catch (error) {
      console.error('Fetch error:', error);
      throw error;
    }
  }
});
export const SummaryPageSlice: any = createSlice({
  name: 'SummaryPageSlice',
  initialState,
  reducers: {
    setCurrentTab: (state, action) => {
      state.currentTab = action.payload;
    },
    setSummarySearchForm: (state, action) => {
      const { key, value } = action.payload;
      state.searchForm[key] = value;
    },

    // setDataForTab: (state, action) => {
    //   const { tabId, data } = action.payload;
    //   state.fetchedData[tabId] = data;
    // },
    setCurrentPaginationOfTheTab: (state, action) => {
      const { tabId, pagination } = action.payload;
      state.currentPaginationOfTabs[tabId] = pagination;
    },
    setCurrentPageSizeOfTabs: (state, action) => {
      const { tabId, pageSize } = action.payload;
      state.currentPageSizeOfTabs[tabId] = pageSize;
    },
    summaryClearForm: (state) => {
      state.searchForm = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSummary.fulfilled, (state: any, action: any) => {
      const { res, shouldUpdateState } = action.payload;
      const { currentTab } = state;
      // Only update the state if shouldUpdateState is true
      if (shouldUpdateState) {
        state.fetchedData[currentTab] = res;
      }
    });
  },
});
//* ------------------Report---------------------
// export const getLlmReport: any = createAsyncThunk<any, { scanId?: string }>('SummaryPageSlice', async ({ scanId }, { getState }) => {
//   const state = getState() as any;
//   const id = scanId || state.appGeneralReducer.persist.userJobScheduleId;
//   if (!id) return;
//   const curl = getApiUrl(apiConfig.llm_report, { userJobScheduleId: id });
//   const response = await axiosIn.get(curl);
//   return { data: response.data, status: response.status };
// });
//* ------------------Chart---------------------
export const fetchCharts: any = createAsyncThunk<any, { scanId?: string }>('SummaryPageSlice', async ({ scanId }, { getState }) => {
  const state = getState() as any;
  const id = scanId || state.appGeneralReducer.persist.userJobScheduleId;
  if (!id) return;

  const keynames_of_charts = ['chart_headers', 'chart_ports', 'chart_subdomains', 'chart_vulnerabilities'];
  keynames_of_charts.forEach((i: string) => dispatch(setIsLoadings({ key: i, value: true })));

  const responses = await Promise.all([
    axiosIn.get(getApiUrl(apiConfig.chart_headers, { userJobScheduleId: id })),
    axiosIn.get(getApiUrl(apiConfig.chart_ports, { userJobScheduleId: id })),
    axiosIn.get(getApiUrl(apiConfig.chart_subdomains, { userJobScheduleId: id })),
    axiosIn.get(getApiUrl(apiConfig.chart_vulnerabilities, { userJobScheduleId: id })),
  ]);

  keynames_of_charts.forEach((item: string, index: number) => {
    dispatch(setPersist({ item, value: responses[index].data }));
    dispatch(setIsLoadings({ key: item, value: true }));
  });
});
export const {
  //
  setSummarySearchForm,
  setCurrentTab,
  setCurrentPaginationOfTheTab,
  setCurrentPageSizeOfTabs,
  summaryClearForm,
} = SummaryPageSlice.actions;

export default SummaryPageSlice.reducer;

const mockdata = [
  { id: 1, date: '01/01/2024', value1: -21, description: 'No Cookies', details: 'Lorem 123', value2: 20, value3: 12000, status: 'Active' },
  { id: 2, date: '02/01/2024', value1: 22, description: 'No Cookies', details: 'Lorem 123', value2: 20, value3: 11000, status: 'Standby' },
  { id: 3, date: '03/01/2024', value1: -23, description: 'No Cookies', details: 'Lorem 123', value2: 20, value3: 1000, status: 'Active' },
  { id: 4, date: '04/01/2024', value1: 24, description: 'No Cookies', details: 'Lorem 123', value2: 20, value3: 5000, status: 'Active' },
  { id: 5, date: '05/01/2024', value1: -25, description: 'No Cookies', details: 'Lorem 123', value2: 20, value3: 12000, status: 'Active' },
  { id: 6, date: '06/01/2024', value1: 26, description: 'No Cookies', details: 'Lorem 123', value2: 20, value3: 9000, status: 'Active' },
  { id: 7, date: '07/01/2024', value1: -27, description: 'No Cookies', details: 'Lorem 123', value2: 20, value3: 18000, status: 'Passive' },
  { id: 8, date: '08/01/2024', value1: 28, description: 'No Cookies', details: 'Lorem 123', value2: 20, value3: 2000, status: 'Passive' },
  { id: 9, date: '09/01/2024', value1: -29, description: 'No Cookies', details: 'Lorem 123', value2: 20, value3: 6000, status: 'Active' },
  { id: 10, date: '10/01/2024', value1: 11, description: 'No Cookies', details: 'Lorem 123', value2: 20, value3: 12000, status: 'Active' },
  { id: 11, date: '11/01/2024', value1: -12, description: 'No Cookies', details: 'Lorem 123', value2: 20, value3: 8000, status: 'Active' },
  { id: 12, date: '12/01/2024', value1: -23, description: 'No Cookies', details: 'Lorem 123', value2: 20, value3: 9000, status: 'Active' },
];
